export { MoviesSlider } from './MoviesSlider';
export { SliderButtonNext } from './SliderButtonNext';
export { SliderButtonPrev } from './SliderButtonPrev';
